import { Link } from '@solidjs/meta';

export function Oswald()
{
	return (<>
		<Link rel='preconnect' href='https://fonts.googleapis.com' />
		<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		<Link href='https://fonts.googleapis.com/css2?family=Oswald:wght@200..700&display=swap' rel='stylesheet' />
	</>);
}

Oswald.fontFamily = '"Oswald", sans-serif';
